/* eslint-disable no-nested-ternary */
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import Select from 'react-select';
import {
  Button, DashboardView, DashboardBody, Error, Grid, Spinner, Toolbar,
} from './RPDashboard.styles';
import AppContext from '../../AppContext';
import NavLinkButton from 'Library/GrpGrid/NavLinkButton/NavLinkButton';
import UrlPoller from 'Library/UrlPoller/UrlPoller';
import 'Styles/SCSS/ag-theme-material.scss';
import Auth0SessionInfo from 'Services/Auth0SessionInfo';
import APIM from 'Services/APIM';
import CDATA from 'Services/CDATA';
import { renderWithPermissions } from 'Components/Auth0/permissionFunctions';
import { permissionTypes } from 'Constants/Auth0Constants';

const PreviewButton = () => 'Show Preview';

let PermissionPrefix = '';

const linkData = (data, path) => ({
  pathname: path,
  classcode_bk: data.classcode_bk,
  language: data.iso_languages,
  fundcode_bk: data.fundcode_bk,
  of_full_share_class_name: data.of_full_share_class_name,
  action_type: 'Edit',
  regulation_name: 'CEPT_Perf_v2',
});

const PreviewButtonLink = (data) => (data ? linkData(data, '/regulatory-reporting/preview/ceptresults') : null);

class RPceptV2PerformanceDashboard extends Component {
  constructor(props) {
    super(props);
    this.PermissionPrefix = props.location.pathname.toLowerCase().endsWith('ceptv2performance') ? 'dashboard/' : '';
    this.state = {
      api_name: this.props.api_name,
      displayedRowCount: 0,
      error_or_warning: 'Error',
      failed: false,
      loading: true,
      page: window.location.pathname,
      redirect: false,
      regulation_name: 'CEPT_Perf_v2',
      totalRowCount: 0,
      toolbarButtons: [
        renderWithPermissions(() => (
          <Button
            key={0}
            onClick={() => { this.create(); }}
            size="Medium"
            type="Secondary"
            text="Create CEPTv2 Performance in Bulk"
          />
        ), this.PermissionPrefix + permissionTypes.create, () => <></>),  
        renderWithPermissions(() => (
          <Button
            key={2}
            onClick={async () => {  await this.runSimulations(); }}
            size="Medium"
            type="Primary"
            text="Run Calculation"
          />
        ), this.PermissionPrefix + permissionTypes.calculations, () => <></>),        
        renderWithPermissions(() => (
          <Button
            key={3}
            onClick={() => { this.populateRuleReg(); }}
            size="Medium"
            type="Secondary"
            text="Rule Regulation Population"
          />
        ), this.PermissionPrefix + permissionTypes.generate, () => <></>),

        <Button
          onClick={() => { this.refresh(); }}
          icon={['fas', 'sync']}
          iconSide="Round"
          size="Small"
        />,
      ],
      rowData: [],
      monitorUrl: '',
      monitorType: '',
    };
  }

  componentDidMount() {
    this.getMetadata();
  }

  async getMetadata() {
    try {
      const columns = await CDATA.makeRequest(
        'POST',
        'PRIIPS_app_GET_COLUMNS',
        '',
        {
          API_NAME: 'PRIIPS_app_ceptv2_perf_VALIDATION_DASHBOARD',
          MERGE_QUEUE_ID: -99,
        },
        'Error retrieving column names and metadata.',
      );
      const columnDefs = this.mapColumns(columns.value);

      if (this.state.api_name === 'PRIIPS_app_VALIDATION_DASHBOARD') {
        columnDefs.unshift({
          field: 'Edit',
          headerName: 'CEPTv2 Performance Status',
          cellRenderer: (props) => (
            props.data.status ? (
              props.data.status === 'Not Started' ? (
                <Button
                  className="Secondary"
                  size="Small"
                  text={<div style={{color: '#8700FF'}}>Create</div>}
                  onClick={() => { this.createCEPTv2(props.data.classcode_bk); }}
                />
              ) : props.data.status
            ) : null
          ),
          sortable: true,
          cellClass: 'ag-cell',
          enablePivot: false,
          enableRowGroup: false,
          enableValue: false,
        });

        columnDefs.unshift({
          field: 'Preview',
          headerName: 'Risk & Performance Calculation',
          cellRenderer: (props) => (
            <NavLinkButton
              {...props}
              functionToGenerateContent={PreviewButton}
              functionToGenerateLink={PreviewButtonLink}
            />
          ),
          sortable: true,
          cellClass: 'ag-cell',
          valueGetter: (props) => PreviewButton(props.data),
          enablePivot: false,
          enableRowGroup: false,
          enableValue: false,
        });

        columnDefs.unshift({
          field: 'SelectRow',
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          sortable: false,
          maxWidth: 45,
          resizable: false,
        });
      }

      setTimeout(() => this.setState({ columnDefs, rawColumns: columns.value }),10);
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading the columns for this table. Please try again. If the issue persists, contact your administrator.',
      });
      console.log(err);
    }
  }

  async getData() {
    try {
      this.gridApi.updateGridOptions({ rowData:[]});
      let payload = {
        clientcode: this.context.state.selectedClient.code,
        reportingperiod: this.context.state.selectedReportingDate.code,
        ruleregulation: this.state.regulation_name,
      };
      if (this.state.api_name !== 'PRIIPS_app_VALIDATION_DASHBOARD') {
        payload.resulttodisplay = this.state.error_or_warning;
      }
      const data = await CDATA.makeRequest(
        'POST',
        this.state.api_name,
        '',
        payload,
        'Error retrieving data.',
      );
      const totalRowCount = data && data['@odata.count'] !== 0 ? data['@odata.count'] : data.value.filter((item) => item.return_value !== '0').length;
      const filteredData = data.value.filter((item) => item.return_value !== '0');
      this.setState({ rowData: filteredData });
      setTimeout(
        ()=>{
          this.gridApi.onFilterChanged();
        },
      10);
      this.setState({ loading: false, totalRowCount });
      if (this.state.selectedValue) { 
        const selectedValue = this.state.selectedValue; 
        this.setState(selectedValue); 
      }
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  populateRuleReg = async () => {
    try {
      const ruleReportType = this.state.regulation_name;
      const data = {
        procedure: 'app.PopulateRuleRegulationDashboard',
        clientcode: this.context.state.selectedClient.code,
        parameters: {
          ClientCode: this.context.state.selectedClient.code,
          ReportingPeriod: this.context.state.selectedReportingDate.code,
          RuleRegulation: ruleReportType,
          FundCode: null,
          ClassCode: null
        },
      };

      APIM.makeRequest(
        'transaction',
        JSON.stringify(data),
        'Error in Rule Regulation Population for ' + ruleReportType + '.',
        Auth0SessionInfo.GetSessionInfo().accessToken,
      )
        .then((res) => {
          const toast = {
            type: 'success',
            body: (
              <>
                {'You successfully queued Rule Regulation Population for ' + ruleReportType + '.'}
              </>
            ),
          };
          this.context.handlers.setToast(toast);
          this.setState({ monitorUrl: res.statusQueryGetUri , monitorType: 'Rule Regulation Population for ' + ruleReportType});
          //this.refreshData();
        })
        .catch((error) => {
          console.log(error);
          this.context.handlers.closeModal();
          const toast = {
            type: 'error',
            body: (
              <>
                Error - something went wrong and we were not able to run Rule Regulation Population
              </>
            ),
          };
          this.context.handlers.setToast(toast);
        });

    } catch(err) {
      console.log(err);
    }
  };

  mapColumns = (rawColumns) => rawColumns.map((x) => ({
    field: x.dv_column,
    headerName: x.display_name,
    hide: x.is_hidden,
    editable: x.editable,
    comparator: x.sorttype !== undefined && x.sorttype.toLowerCase() === 'numeric' && ((value1, value2) => (value1 - value2)),
    // this is if you want to do a default sort for a specific column
    sort: x.dv_column.toLowerCase() === 'classcode_bk' ? {
      direction: 'desc',
      priority: 0,
    } : null,
  }));

  onGridReady = async (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    await this.getData();
  };

  onModelUpdated = (params) => {
    if(this.state.displayedRowCount !== params.api.getDisplayedRowCount())
      this.setState({ displayedRowCount: params.api.getDisplayedRowCount() });
  };

  runCalculations = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    const delimClassCodes = listOfRows.map((row) => row.classcode_bk).join(',');
    const delimCategory = listOfRows.map((row) => row.category).filter((value, index, self) => self.indexOf(value) === index).join(',');
    const modalContent = <div><p>{`Running Risk and Performance Calculation for ${listOfRows.length} row(s)...`}</p></div>;
    this.context.handlers.setModal('Running Calculation ...', modalContent, null, null, true);
    // console.log(delimCategory[0])

    let data = {
      procedure: 'app.GenerateCeptPerfV2',
      clientcode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        Class_Codes: delimClassCodes,
        CalcDate: this.context.state.selectedReportingDate.code,
        FromFlexFunds: null,
        RecommendedHoldingPeriod: 40,
        Type: null,
        Use_Entry_Cost: null
      },
    };

    APIM.makeRequest('transaction', JSON.stringify(data), 'Calculations failed.', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => { // res
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You queued '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              {' for the '}
              {delimCategory}
              {' regulation Calculation. Please wait...'}
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({
          monitorUrl: res.statusQueryGetUri,
          monitorType: 'CEPT V2 Perf Calculation'
        });
      })
      .catch(() => { // error
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to run the '}
              <span>{listOfRows.length}</span>
              {' row'}
              {listOfRows.length > 1 ? 's' : ''}
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }


  runSimulations = async () => {
    const listOfRows = this.gridApi.getSelectedRows();    
    const delimClassCodes = listOfRows.map((row) => row.classcode_bk);
    const delimCategory = listOfRows.map((row) => row.category).filter((value, index, self) => self.indexOf(value) === index).join(',');
    const modalContent = <div><p>{`Running Simulations for ${listOfRows.length} row(s)...`}</p></div>;
    this.context.handlers.setModal('Running Simulation ...', modalContent, null, null, true);

    const chunkSize = 400;
    const delimClassCodesChunks = [];
    for (let i = 0; i < delimClassCodes.length; i += chunkSize) {
      delimClassCodesChunks.push(delimClassCodes.slice(i, i + chunkSize));
    }

    for(let i = 0; i < delimClassCodesChunks.length; i++){

      let data = {
        clientcode: this.context.state.selectedClient.code,
        classCodes: delimClassCodesChunks[i],
        referenceDate: this.context.state.selectedReportingDate.code
      };

      await this.callSimulationsProducer(data)

      const toast = {
        type: 'success',
        body: (
          <>
            {'You queued '}
            <span>{delimClassCodes.length}</span>
            {' row'}
            {delimClassCodes.length > 1 ? 's' : ''}
            {' for the '}
            {delimCategory}
            {' regulation Simulations...'}
            .
          </>
        ),
      };
      this.context.handlers.setToast(toast);
    }

  }

  callSimulationsProducer = async (data) => {
    

    await APIM.makeRequest('simulationproducer', JSON.stringify(data), 'Simulations failed.', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => { // res
        this.context.handlers.closeModal();
      })
      .catch(() => { // error
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to run the '}
              <span>{data.classCodes.length}</span>
              {' row'}
              {data.classCodes.length > 1 ? 's' : ''}
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  
  createExtract = async () => {
    if (this.state.totalRowCount === 0) {
      const toast = {
        type: 'error',
        body: (<>No data available to extract.</>),
      };
      this.context.handlers.setToast(toast);
      return;
    }
    const data = {
      procedure: 'CEPT_Prices_Extract',
      ClientCode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        Reference_Date: this.context.state.selectedReportingDate.code,
      },
    };

    APIM.makeRequest('generateExtract', JSON.stringify(data), 'Error CEPT Prices Extract', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You have successfully submitted data extract request.'}
              {'Please check for the results in a few minutes'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ monitorUrl: res.statusQueryGetUri, monitorType: 'CEPT Prices Extract Generation' })
      })
      .catch(() => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              Error - something went wrong and we were not able to generate the extract you requested.
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  handleSelect = (selectedValue) => {
    // console.log(event);
    this.setState({
      error_or_warning: selectedValue.label === 'All Warnings' ? 'Warning' : 'Error',
      api_name: selectedValue.value,
      selectedValue: selectedValue,
      loading: true,
    }, () => { this.refresh(); });
  }

  create = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    if (listOfRows.length > 0) {
      const modalContent = (
        <div>
          <p>
            {`Are you sure you want to create the CEPTv2 Performance for ${listOfRows.length} row(s)?`}
          </p>
          <Button onClick={() => this.createCEPTPerfv2Bulk()} size="Medium" type="Primary" text="Update All Fields" />
          <p style={{ paddingTop: 10 }}>
            <Button
              onClick={() => this.context.handlers.toggleModal()}
              size="Medium"
              type="Primary"
              text="Cancel"
            />
          </p>
        </div>
      );
      this.context.handlers.setModal('Create CEPTv2 Performance', modalContent, null, null, false);
      this.context.handlers.toggleModal();
    } else {
      const toast = {
        type: 'error',
        body: (<>No rows were selected to create the CEPTv2 Performance.</>),
      };
      this.context.handlers.setToast(toast);
    }
  }

  createCEPTPerfv2Bulk = () => {
    const listOfRows = this.gridApi.getSelectedRows();
    const delimClassCodes = listOfRows.map((row) => row.classcode_bk).join(',');
    const modalContent = <div><p>{`Creating CEPTv2 Performance for ${listOfRows.length} row(s)...`}</p></div>;
    this.context.handlers.setModal('Creating CEPTv2 Performance...', modalContent, null, null, true);

    const data = {
      procedure: 'app.Create_CEPT_Perf_v2_Bulk',
      clientcode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        CalcDate: this.context.state.selectedReportingDate.code,
        Class_Codes: delimClassCodes,
        UserName: this.context.state.userEmail
      }
    }
    this.makeCreateCEPTv2PerfBulkRequest(data);
  }

  async createCEPTv2(classcode_bk) {
    const modalContent = (
      <div>
        <p>{`Creating CEPTv2 Performance for ${classcode_bk} ...`}</p>
      </div>
    );
    this.context.handlers.setModal('Creating ...', modalContent, null, null, true);
    this.context.handlers.toggleModal();

    const data = {
      procedure: 'app.Create_CEPT_Perf_v2_Bulk',
      clientcode: this.context.state.selectedClient.code,
      parameters: {
        Client_Code: this.context.state.selectedClient.code,
        CalcDate: this.context.state.selectedReportingDate.code,
        Class_Codes: classcode_bk,
        UserName: this.context.state.userEmail,
        UpdateAll: true,
      }
    }
    this.makeCreateCEPTv2PerfBulkRequest(data);
  }

  async makeCreateCEPTv2PerfBulkRequest(parameters) {
    APIM.makeRequest('transaction', JSON.stringify(parameters), 'Error Creating CEPTv2 Performance', Auth0SessionInfo.GetSessionInfo().accessToken)
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You have submitted an CEPTv2 Performance creation request, please hold'}.
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ monitorUrl: res.statusQueryGetUri, monitorType: 'CEPTv2 Performance'});
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <> 
              {'Error - something went wrong and we were not able to create CEPTv2 Performance reports at this time.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  async refresh() {
    await this.getMetadata();
    await this.getData();
  }

  refreshData() {
    this.setState({ loading: true }, () => this.getData());
  }

  onPollingDone() {
    this.setState({ monitorUrl: undefined });
    this.refreshData();
  }

  render() {
    return (
      <DashboardView>
        <DashboardBody>
          {
            this.state.failed ? <Error text={this.state.failMessage} /> : (
              <>
                {
                  this.state.loading ? <Spinner text="Loading data..." /> : (
                    this.gridApi && (
                      <Toolbar
                        api={this.gridApi}
                        working={this.state.toolbarWorking}
                        exportName={this.state.api_name}
                        controls={this.state.api_name === 'PRIIPS_app_VALIDATION_DASHBOARD' ? this.state.toolbarButtons : null}
                        dropdown={(
                          <Select
                            isSearchable
                            options={[
                              { label: 'Share Class Dashboard', value: 'PRIIPS_app_VALIDATION_DASHBOARD' },
                              { label: 'Business Rule Dashboard', value: 'PRIIPS_app_VALIDATION_BY_RULE' },
                              { label: 'All Errors', value: 'PRIIPS_app_VALIDATION_RESULT_VIEW' },
                              { label: 'All Warnings', value: 'PRIIPS_app_VALIDATION_RESULT_VIEW' },
                            ]}
                            // components={{ Option: CustomOption }}
                            value={this.state.selectedValue}
                            ignoreAccents={false}
                            // filterOption={createFilter({ignoreAccents: false})}
                            onChange={this.handleSelect}
                            isOptionSelected={(option, selectedValue) => {return selectedValue.some((i) => i.label == option.label)}}
                          />
                        )}
                        count={{
                          total: this.state.totalRowCount,
                          showing: this.state.displayedRowCount,
                        }}
                      />
                    )
                  )
                }
                <Grid
                  columnDefs={this.state.columnDefs}
                  rawColumnData={this.state.rawColumns}
                  rowData={this.state.rowData}
                  onGridReady={this.onGridReady}
                  apiName={this.state.api_name}
                  onModelUpdated={this.onModelUpdated}
                  pivotable
                // autoGroupColumnDef = {this.state.autoGroupColumnDef}
                // treeData={this.props.treeData}
                />
              </>
            )
          }
        </DashboardBody>
        <div>
          {
            this.state.monitorUrl ? (
              <UrlPoller
                monitorUrl={this.state.monitorUrl}
                refreshIntervalSeconds={5}
                monitorType={this.state.monitorType}
                endStates={['Completed']}
                completeCallback={() => this.onPollingDone()}
              />
            ) : <></>
          }
        </div>
      </DashboardView>
    );
  }
}

RPceptV2PerformanceDashboard.contextType = AppContext;

export default RPceptV2PerformanceDashboard;
